module.exports = __webpack_public_path__ + "img/deadlines_icon.612f3801.svg";